import { render } from "./search-switchview.vue?vue&type=template&id=3a1b0ba6"
import script from "./search-switchview.js?vue&type=script&lang=js"
export * from "./search-switchview.js?vue&type=script&lang=js"

import "./search-switchview.vue?vue&type=style&index=0&id=3a1b0ba6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__